import { Component, OnInit } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { AuthenticationService } from '../../../_services/authentication.service'
import { RequestsService } from 'src/app/_shared/services/requests.service'
import { CropData } from 'src/app/interfaces/admin.interface'

declare var jQuery: any

@Component({
  selector: 'app-agronomical',
  templateUrl: './agronomical.component.html',
  styleUrls: ['./agronomical.component.scss'],
})
export class AgronomicalComponent implements OnInit {
  activity: any
  model: any = {}
  chosenActivities = []
  crop: any
  chosenCrops = []
  title: any
  inputs: any
  searchItem: string
  filterInputs: any
  selectedInfo: object[] = []
  selectedServiceInfo: object[] = []
  selectedInputName: string
  chosenTitles = []
  choosetitle: any
  page = 1
  count = 10
  showFilter = false
  type = 'maize'
  cropInfos = []
  private _cropName: string
  get cropName() {
    return this._cropName
  }
  set cropName(value: string) {
    this._cropName = value
    this.filteredData = this.filterCrop(value)
  }
  filteredData = []
  submitted: boolean = false
  form: FormGroup
  cropInfoData: object
  editInfoData: object
  deleteInfoData: object
  editCropId: string

  requiredField: any = {
    description: false,
    photo: false,
  }
  columns = []
  services: any
  public action = null
  selectedUser
  actionSuccess = false
  userId: string = null
  id: string = null
  url: string
  error: string

  CropId = null
  crops: CropData[]
  country_id: string
  country_name: string
  success = false
  loading = false
  message: string

  openDeleteModal: boolean = false
  openEditModal: boolean = false
  openAddModal: boolean = false
  openSuccessModal: boolean = false

  createAgroInfoisSuccess: boolean
  createCropIsSuccess: boolean
  createCropIsFailed: boolean
  serverError: boolean
  editAgroInfoisSuccess: boolean
  editError: boolean
  deleteAgroInfoisSuccess: boolean
  deleteError: boolean

  addModal: boolean = false
  successModal: boolean = false
  parts: any
  cropData: any
  cropHeading: any

  selectedImage: File = null
  changeImage(event) {
    this.selectedImage = <File>event.target.files[0]
  }

  quillConfig = {
    toolbar: [
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['bold', 'italic', 'underline'],
      [{ header: 1 }, { header: 2 }],
      ['clean'],
    ],
  }

  constructor(
    private requestService: RequestsService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country_id, country } = currentUser
    this.country_id = country_id
    this.country_name = country
    if (this.country_name === 'Uganda') {
      this.parts = [
        'Spraying',
        'Soil testing',
        'Tractor hire',
        'Garden mapping',
      ]
    } else if (this.country_name === 'India') {
      this.parts = ['Garden mapping']
    }

    // this.getCrops();
    this.getCropsData()
    this.getHeadingsData()
    this.getServices()
    this.getCropInfo()
    this.getInputs()
    this.columns = [
      { field: 'crop', header: 'Crop' },
      { field: 'purpose', header: 'Activity' },
      { field: 'title', header: 'Title' },
      { field: 'description', header: 'Description' },
    ]
  }

  filterCrop(searchString: string) {
    return this.cropInfos.filter(
      (cropInfo) =>
        cropInfo.crop.toLowerCase().indexOf(searchString.toLowerCase()) !== -1
    )
  }

  getCrops() {
    this.requestService.get(`crops`, null).subscribe((res) => {
      this.crops = res.data
    })
  }

  getCropsData() {
    this.loading = true
    this.requestService
      .dash_get(`enterprises/${this.country_name}`, null)
      .subscribe((res) => {
        this.loading = false
        this.cropData = res
        this.crops = res.data
      })
  }

  getHeadingsData() {
    this.loading = true
    this.requestService
      .dash_get(`dashboard/agronomical-info-heading/${this.country_name}`, null)
      .subscribe((res) => {
        this.loading = false
        this.cropHeading = res
      })
  }

  getServices() {
    this.requestService.dash_get('services', null).subscribe((res) => {
      this.services = res.results
    })
  }

  getCropInfo() {
    this.loading = true
    this.requestService
      .dash_get(`dashboard/agronomical-info/${this.country_name}`, null)
      .subscribe((res) => {
        this.loading = false
        this.cropInfos = res.agronomicalInfo
        this.filteredData = res.agronomicalInfo
        let all_titles = []
        let all_crops = []
        let all_activities = []

        res.agronomicalInfo.map((each) => {
          all_crops.push({ label: each.crop, value: each.crop })
          all_activities.push({ label: each.purpose, value: each.purpose })
          all_titles.push({ label: each.title, value: each.title })
        })
        this.chosenActivities = all_activities.filter(
          (value, index, array) =>
            !array.filter(
              (v, i) => JSON.stringify(value) == JSON.stringify(v) && i < index
            ).length
        )
        this.chosenCrops = all_crops.filter(
          (value, index, array) =>
            !array.filter(
              (v, i) => JSON.stringify(value) == JSON.stringify(v) && i < index
            ).length
        )
        this.chosenTitles = all_titles.filter(
          (value, index, array) =>
            !array.filter(
              (v, i) => JSON.stringify(value) == JSON.stringify(v) && i < index
            ).length
        )
      })
  }

  Clear(agronotable) {
    this.title = null
    this.choosetitle = null
    this.crop = null
    agronotable.filter(null, 'title', 'in')
    agronotable.filter(null, 'purpose', 'in')
    agronotable.filter(null, 'crop', 'in')
  }
  viewInfoDetails(data: object): void {
    this.cropInfoData = data
  }

  retrieveInputName(inputId: string) {
    this.loading = true
    this.requestService
      .dash_get(`mobile/input/${inputId}`, null)
      .subscribe((res) => {
        this.loading = false
        this.selectedInputName = res.data
        // this.recommendInput = {id:inputId,name:this.selectedInputName};
        this.selectedInfo.push({ id: inputId, name: this.selectedInputName })
      })
  }

  editInfoDetails(data: object, recommendInput: any): void {
    this.editInfoData = data
    console.log(recommendInput)
    if (recommendInput != undefined) {
      recommendInput.map((element) => {
        this.retrieveInputName(element.value)
      })
    }
  }

  deleteInfoDetails(data: object): void {
    this.deleteInfoData = data
  }

  handleSubmit(updateInputForm, id) {
    this.loading = true
    const form = updateInputForm
    const URL = `dashboard/agronomical-info-update/${id}`
    let formData = new FormData()

    formData.append('crop', form.crop)
    formData.append('purpose', form.purpose)
    formData.append('title', form.title)
    formData.append('description', form.description)
    formData.append('position', form.position)
    formData.append('input', form.input)
    formData.append('service', form.service)
    if (this.selectedImage)
      formData.append('photo', this.selectedImage, this.selectedImage.name)
    this.requestService.dash_putWithImage(URL, formData).subscribe(
      (response) => {
        this.submitted = true
        this.loading = true
        if (response.success) {
          this.editAgroInfoisSuccess = true
          this.getCropInfo()
        } else if (!response.success) {
          this.loading = false
          this.message = response.message
          this.editError = true
        }

        // this.message = response.message;
        // this.successModal = true;
        // this.reloadInputs();
      },
      (error) => {
        this.loading = false
        this.message = 'Some error occurred. Please try again'
        this.editError = true
      }
    )
  }

  deleteInput(id) {
    this.loading = true
    this.requestService
      .dash_delete(id, 'dashboard/agronomical-info-update')
      .subscribe(
        (response) => {
          this.loading = false
          this.deleteAgroInfoisSuccess = true
          this.getCropInfo()
        },
        (errorResponse) => {
          this.loading = false
          this.deleteError = true
        }
      )
  }

  createCrop(createCropForm) {
    this.loading = true
    let formData = new FormData()
    if (this.selectedImage)
      formData.append('photo', this.selectedImage, this.selectedImage.name)
    formData.append('crop', createCropForm.name)
    this.requestService
      .dash_putWithImage(`enterprises/${this.country_name}`, formData)
      .subscribe(
        (response) => {
          this.loading = false
          if (response.success == true) {
            this.success = response.success
            this.createCropIsSuccess = response.success
            this.createCropIsFailed = false
            this.message = response.message
            this.reloadInputs()
          } else if (response.success == false) {
            this.success = response.success
            this.createCropIsSuccess = false
            this.createCropIsFailed = true
            this.message = response.message
          }
        },
        (errorResponse) => {
          this.loading = false
          const { error } = errorResponse
          return (this.error = error.error)
        }
      )
  }

  createAgroInfo(agroInfoForm) {
    this.loading = true
    let formData = new FormData()
    if (this.selectedImage)
      formData.append('photo', this.selectedImage, this.selectedImage.name)
    formData.append('crop', agroInfoForm.name)
    formData.append('title', agroInfoForm.title)
    formData.append('purpose', agroInfoForm.purpose)
    formData.append('description', agroInfoForm.description)
    formData.append('position', agroInfoForm.position)
    formData.append('input', agroInfoForm.input)
    formData.append('service', agroInfoForm.service)
    this.requestService
      .dash_putWithImage(
        `dashboard/agronomical-info/${this.country_name}`,
        formData
      )
      .subscribe(
        (response) => {
          this.loading = false
          this.success = true
          if (response.success) {
            this.createAgroInfoisSuccess = true
            this.getCropInfo()
          } else if (!response.success) {
            this.createAgroInfoisSuccess = false
            this.message = response.message
            this.serverError = true
          }

          // this.message = response.message;
          // this.reloadInputs();
        },
        (errorResponse) => {
          this.loading = false
          this.createAgroInfoisSuccess = false
          this.message = 'Some error occurred. Please try again'
          this.serverError = true
          // const { error } = errorResponse;
          // return (this.error = error.error);
        }
      )
  }

  catchError(errorResponse) {
    this.loading = true
    this.error = errorResponse.error
  }

  prepareToAddCrop() {
    this.addModal = true
    this.successModal = false
  }

  reloadInputs() {
    window.location.reload()
  }

  refreshCropList() {
    this.getCrops()
  }

  closeCropModal() {
    this.addModal = false
  }

  clearCropId() {
    this.CropId = null
  }

  resetModal() {
    // this.modal.hide();
    jQuery('#agroModal').modal('hide')
    this.createAgroInfoisSuccess = false
    this.serverError = false
    this.selectedImage = <File>null
  }

  resetEditModal() {
    // this.modal.hide();
    jQuery('#inputModal').modal('hide')
    this.editAgroInfoisSuccess = false
    this.editError = false
    this.selectedImage = <File>null
  }

  resetDeleteModal() {
    // this.modal.hide();
    jQuery('#deleteModal').modal('hide')
    this.deleteAgroInfoisSuccess = false
    this.deleteError = false
  }

  getMessage(message: string) {
    this.message = message
    this.addModal = false
    this.successModal = true
  }

  clearErrorMessage(input) {
    if (input.name === 'description') {
      this.requiredField.explanation = false
    }
  }

  getInputs() {
    this.loading = true
    this.requestService
      .dash_get(`mobile/input/${this.country_name}`, null)
      .subscribe((res) => {
        this.loading = false
        this.inputs = res.data
        this.filterInputs = res.data
      })
  }

  filterFunction() {
    this.searchItem = jQuery('#searchBox').val()
    // console.log(this.inputs);
    this.filterInputs = this.inputs.filter(
      (input) =>
        input.name.toLowerCase().indexOf(this.searchItem.toLowerCase()) !== -1
    )
    // console.log(this.searchItem);
  }
}
